import { create, StateCreator } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface InternetConnectionState {
  showConnectionError: boolean;
  setShowConnectionError: (connected: boolean) => void;
}

const initialStateCreator: StateCreator<InternetConnectionState, any> = (set) => ({
  showConnectionError: false,
  setShowConnectionError: (showConnectionError) => {
    set((state) => ({
      ...state,
      showConnectionError,
    }));
  },
});

const useInternetConnectionStore = create(
  devtools(
    persist(initialStateCreator, {
      name: "internet-connection-storage",
      storage: createJSONStorage(() => sessionStorage),
    })
  )
);

export default useInternetConnectionStore;
